module.exports = __webpack_public_path__ + "img/banner-inter2.5038ff6f.jpg";